import React from 'react';
import { Helmet } from 'react-helmet-async';

import { Typography } from 'antd';

import UnknownFormsGrid from '../components/unknown-forms/UnknownFormsGrid';
import { QuestionOutlined } from '@ant-design/icons';

const UnknownFormsPage = () => {
  return (
    <>
      <Helmet>
        <title>Unknown Forms | Mabel</title>
      </Helmet>
      <Typography.Title level={3}>
        <QuestionOutlined /> Unknown Forms
      </Typography.Title>
      <UnknownFormsGrid />
    </>
  );
};

export default UnknownFormsPage;
